<template>
  <div>
    <slot />
  </div>
</template>

<script setup>

</script>

<style>

</style>